module.exports = __webpack_public_path__ + "fonts/cuSHdbaj.woff2";